/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Updaterequiredbtnreload3Inputs */



/**
* | output |
* | --- |
* | "Reload" |
*
* @param {Updaterequiredbtnreload3Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const updaterequiredbtnreload3 = /** @type {((inputs?: Updaterequiredbtnreload3Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Updaterequiredbtnreload3Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Reload")
	if (locale === "es") return /** @type {LocalizedString} */ ("Recargar")
	return /** @type {LocalizedString} */ ("Перезагрузить")
});
export { updaterequiredbtnreload3 as "updateRequiredBtnReload" }